<sim-snackbar icon="fa-exclamation-triangle" [duration]="data.duration">
	<label label [innerHTML]="errorMessage() | translate"></label>
</sim-snackbar>
